import request from '@/utils/request'
import backendUrls from '@/config/globalConfig';

export function getBanner() {
    return request({
        url: backendUrls.url + '/essayBanner/getBanner',
        method: 'get'
    })
}

export function getFeaturedEssayList() {
    return request({
        url: backendUrls.url + '/essayInfo/getTopEssayList',
        method: 'get'
    })
}

export function getPage(data) {
    return request({
        url: backendUrls.url + '/essayInfo/page',
        method: 'post',
        data: data
    })
}

export function getEssayListLikeSubject(data) {
    return request({
        url: backendUrls.url + '/essayInfo/getEssayListLikeSubject',
        method: 'post',
        data: data
    })
}

export function addComment(data) {
    return request({
        url: backendUrls.url + '/essayComment/addComment',
        method: 'post',
        data: data,
        headers: {
            isSaToken: true
        }
    })
}

export function getCommentPage(data) {
    const essayId = data.records && data.records[0]
    return request({
        url: backendUrls.url + '/essayComment/articles/' + essayId + '/comments',
        method: 'get',
        params: { pageNum: data.current || 1, pageSize: data.size || 10 }
    })
}

export function getNextCommentPage(data) {
    const commentId = data.records && data.records[0]
    return request({
        url: backendUrls.url + '/essayComment/comments/' + commentId + '/replies',
        method: 'get',
        params: { pageNum: data.current || 1, pageSize: data.size || 10 }
    })
}

export function getCommentTotalByReplyCommentId(commentId) {
    return request({
        url: backendUrls.url + '/essayComment/getCommentTotalByReplyCommentId?commentId=' + commentId,
        method: 'get',
    })
}

export function getDoubleNextCommentDoubleTotal(commentId) {
    return request({
        url: backendUrls.url + '/essayComment/getDoubleNextCommentDoubleTotal?commentId=' + commentId,
        method: 'get',
    })
}

export function like(data) {
    return request({
        url: backendUrls.url + '/essayLike/like',
        method: 'post',
        data: data,
        headers: {
            isSaToken: true
        }
    })
}

export function dislike(data) {
    return request({
        url: backendUrls.url + '/essayLike/dislike',
        method: 'post',
        data: data
    })
}

export function deleteComment(data) {
    return request({
        url: backendUrls.url + '/essayComment/deleteComment',
        method: 'post',
        data: data,
        headers: {
            isSaToken: true
        }
    })
}

export function info(essayId) {
    return request({
        url: backendUrls.url + '/essayInfo/info?essayId=' + essayId,
        method: 'get'
    })
}

export function readEssay(essayId) {
    return request({
        url: backendUrls.url + '/essayInfo/readEssay?essayId=' + essayId,
        method: 'get'
    })
}

export function getNewEssayList(essayId) {
    return request({
        url: backendUrls.url + '/essayInfo/getNewEssayList',
        method: 'get'
    })
}

export function getCalendar(month) {
    return request({ url: backendUrls.url + '/essayInfo/calendar', method: 'get', params: { month } })
}
